<template>
  <div class="home-wrap">
    <div class="padding-12-15 padding-b-30">
      <div class="title-text">我的推广位</div>
      <div class="desc">您创建电影票专属推广链接时，需要关联您的推广位。推广位用于记录您投放于不同渠道的影票推广链接转化效果</div>
      <div class="padding-t-30">
        <div class="create-btn" @click="addManage()">
          <img src="../../../../assets/img/btn_add.png" alt="">添加推广位
        </div>
      </div>
    </div>
    <div class="gray"></div>
    <div class="padding-12-15 padding-b-8">
      <div class="title-text">推广位数据趋势</div>
      <div class="table-wrapper">
        <el-table :data="list" border style="width: 100%">
          <el-table-column prop="date" label="推广位名称" width="100">
            <template slot-scope="{row}">
              <span>{{ row.app_name }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="AppKey" width="100">
            <template slot-scope="{row}">
              <span>{{ row.app_key }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="接口密钥AppSecret" width="100">
            <template slot-scope="{row}">
              <span>{{ row.app_secret }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="备注" width="90">
            <template slot-scope="{row}">
              <span>{{ row.remark }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="api调用权限" width="110">
            <template slot-scope="{row}">
              <span>{{ row.api_auth_str }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="状态" width="110">
            <template slot-scope="{row}">
              <span class="status-text-success" v-if="row.status == 1">正常</span>
              <span class="status-text-reject" v-else>禁用</span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="155" class-name="text-center">
            <template slot-scope="{row}">
              <el-button @click="getLink(row)" type="text" size="small" style="color: #FF4F76;">获取链接</el-button>
              <el-button @click="toReport(row)" type="text" size="small" style="color: #FF4F76;">查看报表</el-button>
              <el-button @click="editManage(row)" type="text" size="small" style="color: #FF4F76;">修改</el-button>
            </template>
          </el-table-column>
        </el-table>
        <pagination v-show="total>0" :total="total" :page.sync="searchForm.page" :limit.sync="searchForm.pagesize" @pagination="getList" />
      </div>
    </div>
    <AddManage ref="AddManage" @refreshList="getList(true)"/></AddManage>
    <GetLinked ref="GetLinked" @refreshList="getList(true)"/></GetLinked>
  </div>
</template>

<script>
  import Pagination from '@/components/Pagination' // secondary package based on el-pagination
  import { getPromotionList } from '@/api/promotion'
  import AddManage from '@/views/h5/promotion/manage/modal/AddManage'
  import GetLinked from '@/views/h5/promotion/manage/modal/GetLinked'
  export default {
    name: 'PromotionHome',
    components: {
      Pagination,
      AddManage,
      GetLinked,
    },
    data () {
      return {
        list: [],
        listLoading: false,
        total:0,
        searchForm:{
          page: 1,
          pagesize: 10,
        },
        show: false,
      }
    },
    mounted: function () {
      this.getList(true)
      this.listLoading = true
      this.listLoading = false
    },
    methods: {
      getList(first = false){
        this.listLoading = true
        if(first) this.searchForm.page = 1
        getPromotionList(this.searchForm).then((response) => {
          this.listLoading = false
          if(response.code != 200){
            this.$Message.error(response.msg)
            return
          }
          this.list = response.data.list
          this.total = response.data.total
        })
      },
      // 获取链接
      getLink: function (row) {
        this.$refs.GetLinked.init(true, row)
      },
      //添加推广位
      addManage: function () {
        this.$refs.AddManage.init(true, {})
      },
      //编辑推广位
      editManage: function (row) {
        this.$refs.AddManage.init(false, row)
      },
      //查看推广位
      toReport(row){
        this.$store.dispatch('h_nav/changePromotionActiveIndex',2)
        this.$router.push({ path: '/h5/promotion/report', query: { app_key: row.app_key }})
      },
    }
  }
</script>

<style lang="less" scoped>
  .home-wrap{
    font-family: Alibaba-PuHuiTi-R;
    .create-btn{
      width: 64%;
      margin: 0 auto;
      font-size:15px;
      text-align:center;
      border: 1px solid #FF8622;
      border-radius: 35px;
      height: 35px;
      line-height: 33px;
      color: #FF8622;
      img{
        width: 18px;
        margin-right: 10px;
      }
    }
    .table-wrapper {
      width: 100%;
      margin-top: 8px;
      .status-text-success {
        font-size: 14px;
        color: #3d9efc;
      }
      .status-text-reject {
        font-size: 14px;
        color: #ff8622;
      }
    }
  }
  /deep/.el-button+.el-button{
    margin-left: 0;
  }
  input::-webkit-input-placeholder,textarea::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #C1C1C1;
  }
  input:-moz-placeholder,textarea:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #C1C1C1;
  }
  input::-moz-placeholder,input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #C1C1C1;
  }
  input:-ms-input-placeholder,textarea:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: #C1C1C1;
  }
</style>



// WEBPACK FOOTER //
// src/views/h5/promotion/manage/Index.vue